import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SC_Input } from '../../../../common/input/SC_Input';
import { MountingSystem } from '../../../../common/mountsys/MountingSystem';
import { Sol50OnRoof } from '../../../../common/mountsys/Sol50OnRoof';
import { ModList } from '../../../../common/panel/ModList';
import { SC_Beam } from '../../../../common/roof/SC_Beam';
import { Statics } from '../../../../common/utilities/statics';
import { TranslateService } from "../../../../common/variables/translate-service";
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { GlobalService } from "../../../../common/services/global.service";
import { Global } from '../../../../common/utilities/global';

@Component({
  selector: 'sen-app-variety-profile',
  templateUrl: './variety-profile.component.html',
  styleUrls: ['./variety-profile.component.scss']
})
export class VarietyProfileComponent implements OnInit {
  displayedColumns: string[] = ['hProfileName', 'price'];
  dataSource = new MatTableDataSource();
  selectedProfile: string = '';
  hProfileName: string;

  constructor(public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VarietyProfileComponent>,
    public global: GlobalVariableService,
    public globalService: GlobalService) {
    this.hProfileName = data.hProfileName;
  }

  ngOnInit(): void {
    this.loopVariations();
  }

  private loopVariations(): void {
    let aHProfiles: string[];
    let sTmp: String = "";
    let hProfiles = [];
    aHProfiles = GlobalVariableService.aHProfiles;
    for (let i = 0; i < aHProfiles.length; i++) {
      Statics.initStatics(aHProfiles[i]);
      let tempH = {
        name: aHProfiles[i],
        items: MountingSystem.getStocklist()
      };
      tempH.items.map(i => delete i.senItemID);
      // console.log();
      // if (ModList.isValid()) {
      //   sTmp += MountingSystem.getStocklist() + ";";
      //   sTmp.split('|').forEach(item => {
      //     let tempI = {
      //       code: item.split(":")[0],
      //       quantity: item.split(":")[1]
      //     }
      //     if (parseInt(tempI.quantity)) {
      //       tempH.items.push(tempI);
      //     }
      //   });
      // }
      hProfiles.push(tempH);
    }
    this.loadVariations(hProfiles);
  }

  public loadVariations(sStockList: any): void {
    let option: any = {
      hProfiles: sStockList
    };
    const qParam = {
      cmd: this.global.HProfileGetAll
    };
    //Stockschrauben 
    if (SC_Input.bBeam) {
      if (SC_Input.iBeamType == SC_Beam.PURLIN) {
        if (SC_Input.sStosch) {
          //TBD
          // option.stosch = SC_Input.sStosch;
          // option.stoschcnt = Sol50OnRoof.getStoSch();
        }
      }
    }
    this.globalService.postData(qParam, option).subscribe(data => {
      try {
        if (data && data.ok) {
          this.dataSource = new MatTableDataSource(data.ok.data.hProfiles);
        }
      } catch { }
    })
  }

  setHProfile(row: any) {
    Statics.initStatics(row.hProfileName);
    this.hProfileName = row.hProfileName;
  }

  onClick(): void {
    this.dialogRef.close(this.hProfileName);
  }

  getLocalString(str: any) {
    if(window.localStorage.getItem("lng") == 'de'){
      return str;
    }
    return Global.convertToLocalNumber(str.replaceAll(".","").replace("€","").replace(",",".")) + " €";
  }
}
